import React from 'react';
import * as Styled from './EmptyState.styles';
import Icon from '@mdi/react';
import { mdiInformationOutline } from '@mdi/js';
import { Trans } from 'react-i18next';

const EmptyState: React.FC = () => {
  return (
    <Styled.Container>
      <Icon path={mdiInformationOutline} size='3rem' />
      <br />
      <Trans i18nKey={'common.emptyState'} />
    </Styled.Container>
  );
};

export default EmptyState;
